<template>
  <div id="PaSchoolsList">
    <!-- Mobile Layout -->
    <v-container class="d-md-none" mt-4 px-1>
      <v-card
        v-for="school in filteredSchools"
        :key="school.id"
        avatar
        tile
        class="mx-2 mt-3"
        id="tileCard"
      >
        <v-list two-line suheader>
          <v-list-item @click="moreInfo(school.school_name)">
            <v-list-item-avatar>
              <v-img :src="school.program_image" alt=""></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="blue--text text--darken-3">{{
                school.school_name
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                school.program_state
              }}</v-list-item-subtitle>
              <!-- <v-list-tile-sub-title><v-icon color="red lighten-2" small>today</v-icon>{{school.application_deadline | moment(" MMMM Do, YYYY")}}</v-list-tile-sub-title> -->
              <!-- <span class="caption ">{{school.application_deadline | moment(" MMMM Do, YYYY")}}</span> -->
            </v-list-item-content>

            <v-list-item-action>
              <v-btn class="" icon :ripple="false">
                <v-icon color="grey">mdi-chevron-right</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-container>

    <!-- Desktop Layout -->
    <v-container class="hidden-sm-and-down" pt-0 px-1>
      <v-row>
        <v-col
          class="pt-0"
          sm="6"
          md="4"
          v-for="school in filteredSchools"
          :key="school.id"
        >
          <v-card class="mt-5 cardStyle" hover @click="moreInfo(school.school_name)">
            <v-card-title class="d-block text-truncate">
              <v-avatar>
                <img :src="school.program_image" />
              </v-avatar>
              {{ school.school_name }}
            </v-card-title>

            <v-card-text class="pt-1">
              <span class="text--primary"
                ><b>State:</b> <span>{{ school.program_state }}</span></span
              >
              <br />
              <span class="text--primary"
                ><b>Accreditation Status:</b>
                <span
                  :class="{
                    'red--text': school.accreditation_status === 'Withheld',
                    'amber--text text--darken-3':
                      school.accreditation_status === 'Probationary',
                    'blue--text text--lighten-1':
                      school.accreditation_status === 'Provisional',
                    'green--text': school.accreditation_status === 'Continued',
                  }"
                >
                  {{ school.accreditation_status }}</span
                ></span
              ><br />
              <span class="text--primary">
                <span
                  ><b>Application Deadline:</b>
                  <span
                    v-if="
                      school.application_deadline !== '' &&
                      school.caspa_participant
                    "
                    class="subheading mb-0"
                    >{{
                      school.application_deadline | moment(" MM/DD/YYYY")
                    }}</span
                  >
                  <span
                    v-if="
                      school.direct_school_application_deadline &&
                      school.direct_school_application
                    "
                    >{{
                      school.direct_school_application_deadline
                        | moment(" MM/DD/YYYY")
                    }}</span
                  >
                  <span
                    v-if="
                      (school.application_deadline === '' ||
                        school.application_deadline === undefined) &&
                      (school.direct_school_application_deadline === '' ||
                        school.direct_school_application_deadline === undefined)
                    "
                    class="grey--text"
                    >Not Listed</span
                  >
                </span>
                <br />
              </span>
              <div class="stripeBox">
                <span
                  :class="{
                    'red--stripe': school.accreditation_status === 'Withheld',
                    'amber--stripe':
                      school.accreditation_status === 'Probationary',
                    'blue--stripe':
                      school.accreditation_status === 'Provisional',
                    'green--stripe':
                      school.accreditation_status === 'Continued',
                    'grey--stripe':
                      school.accreditation_status ===
                        'Developing-Not Accredited' ||
                      school.accreditation_status === 'Pending',
                  }"
                ></span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  props: ["filteredSchools"],
  data() {
    return {};
  },
  methods: {

    moreInfo(id) {
     
      this.$router.push("/paschool/" + id.split(' ').join('-'));
    },
    back() {
      this.$router.go("-1");
    },
  },
};
</script>

<style scoped>
.background {
  background-color: rgb(247, 247, 247);
}
.card--flex-toolbar {
  margin-top: -64px;
}

hr {
  position: absolute;
  width: 80%;
  margin-top: 35px;
  opacity: 0.5;
}

img {
  width: 45px;
  height: 45px;
  margin-right: 5px;
}
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.blueHeading {
  color: rgb(54, 54, 54);
}

#schoolCard {
  margin-top: 20px;
  z-index: 1;
}

#icons {
  width: 30px;
  height: 30px;
}

.schoolList {
  margin-top: 60px;
  margin-bottom: 45px;
}

.closeButton {
  bottom: 0;
  right: 0;
  position: fixed;
}

#tileCard {
  border-radius: 10px;
  box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.19);
}



.stripeBox {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 8px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  overflow: hidden;
}

.red--stripe,
.amber--stripe,
.blue--stripe,
.grey--stripe,
.green--stripe {
  border-top: 10px solid transparent;
  display: block;
}
.red--stripe {
  border-color: #f44336;
}
.amber--stripe {
  border-color: #ff8f00;
}
.blue--stripe {
  border-color: #42a5f5;
}
.green--stripe {
  border-color: #4caf50;
}
.grey--stripe {
  border-color: #777777;
}
</style>



// WEBPACK FOOTER //
// src/components/Schools/PaSchoolsList.vue